/* COLHIDA — revelação suave ao rolar. Sem dependências. */
(function () {
  var run = function () {
    var els = document.querySelectorAll('.clh-reveal:not(.is-in)');
    if (!els.length) return;
    if (!('IntersectionObserver' in window) ||
        window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      els.forEach(function (el) { el.classList.add('is-in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); }
      });
    }, { threshold: 0.1, rootMargin: '0px 0px -5% 0px' });
    els.forEach(function (el) { io.observe(el); });
  };

  document.addEventListener('DOMContentLoaded', run);
  document.addEventListener('shopify:section:load', run);
  run();
})();